export default __webpack_public_path__ + "static/media/performance.195234f5.png";